module.exports = __webpack_public_path__ + "media/images/top-page_map-ac660ead4b88e48beedfbba99e37474d.svg";